<template>
	<button
			:class="[
					'white-btn button',
					'size-'+size,
					'width-'+width,
			]"
			@click.prevent.stop="onClick"
			:disabled="disabled"
	>
			{{ label }}
	</button>
</template>
<script>
	export default {
		name: 'SimplementsWhiteButton',
		props: {
			label: {
				type: String
			},
			disabled: {
				type: Boolean
			},
			size: {
				type: String,
				default: 'lg'
			},
			width: {
				type: String,
				default: 'full'
			}
		},
		methods: {
			onClick(event){
				this.$emit('click', event)
			}
		}
	}
</script>
<style scoped>
	@import url(./assets/basic.css);
	.button.white-btn,
	.button.white-btn:hover,
	.button.white-btn:active{
		background: var(--white, #fff) !important;
		color: var(--primary, rgba(72, 142, 83, 0.93));
	}
	.button.white-btn:hover{
		color: var(--neutral10) !important;
	}
	.button.white-btn:disabled{
		color: var(--neutral-30, #797980) !important;
	}
</style>